export const EXTRA_PORTFOLIO_BENCHMARKS = [
  { name: "S&P Regional Banking ETF", symbol2: "kre" },
  { name: "Invesco KBW Bank ETF", symbol2: "kbwb" },
];

export const NO_EXTRA_BENCHMARKS = [];

const EXTRA_BENCHMARK_EMAILS = [
  "chuck@bluelioncap.com",
  "sameera@9823capital.com",
  "michaelanderson1303@gmail.com",
];

const collectEmails = (user, userInfo) =>
  [
    userInfo?.email,
    userInfo?.username,
    user?.email,
    user?.username,
    user?.attributes?.email,
  ]
    .map((value) => String(value || "").trim().toLowerCase())
    .filter(Boolean);

export const shouldShowExtraPortfolioBenchmarks = (user, userInfo) =>
  collectEmails(user, userInfo).some((email) =>
    EXTRA_BENCHMARK_EMAILS.includes(email)
  );

export const extraPortfolioBenchmarksFor = (user, userInfo) =>
  shouldShowExtraPortfolioBenchmarks(user, userInfo)
    ? EXTRA_PORTFOLIO_BENCHMARKS
    : NO_EXTRA_BENCHMARKS;
